// extracted by mini-css-extract-plugin
module.exports = {"modal":"member-status-info_modal__Ycgau","title":"member-status-info_title__2Zs8m","desc":"member-status-info_desc__2PHu_"};